import React, { useCallback, useEffect, useState } from 'react';
import './AccountSettingsModal.css';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Container,
    Row,
    Col,
} from 'reactstrap';
import classNames from 'classnames';
import { getAuthUser } from '../../../../static/localStorage';
import { getUserByUid, updateUser } from '../../../../firebase/api/users';
import {
    doEmailUpdate,
    doPasswordUpdate,
    doSignOut,
    reauthenticate,
} from '../../../../firebase/api/auth';
import ConfirmPassword from '../ConfirmPassword/ConfirmPassword';
import { ConfirmationModal } from '../../modal/ConfirmModal';
import { AccountSecurityIcon } from '../../icons/Icons';
import { compose } from 'recompose';
import { withAuthorization } from '../../../../session';
import industries from '../../../../static/industries';
import PaymentSection from './PaymentSection';
import { ReactComponent as ModalIcon } from './ModalIcon.svg';
import DelimiterIcon from './DelimiterIcon.png';
import { useAuth } from '../../../../hooks/useAuth';
import CloseAccount from '../../../account/CloseAccount';
import { ReactComponent as SecurityIcon } from './security-icon.svg';
import SecuritySettings from './SecuritySettings';
import { IS_SIDEKICK_APP } from '../../../../constants/projects';

const AccountSettingsModal = ({ modal, toggle }) => {
    const [accountDetailsDTO, setAccountDetailsDTO] = useState(getAuthUser());

    const {
        currentUser: { earned = 0, donated = 0 },
    } = useAuth();

    useEffect(() => {
        if (accountDetailsDTO && accountDetailsDTO.uid) {
            getUserByUid(accountDetailsDTO.uid).then(user => {
                setAccountDetailsDTO({
                    ...accountDetailsDTO,
                    ...user,
                });
            });
        }
    }, []);

    const onTextInputChange = useCallback(
        event => {
            const newAccountDetailsDTO = { accountDetailsDTO };
            newAccountDetailsDTO[event.target.name] = event.target.value;
            setAccountDetailsDTO(newAccountDetailsDTO);
        },
        [accountDetailsDTO]
    );

    return (
        <Modal isOpen={modal} toggle={toggle} className="account-settings-modal">
            <ModalHeader toggle={toggle} className="account-settings__header">
                <ModalIcon />
                Profile
                <img src={DelimiterIcon} alt="delimiter" className="mx-3" />
                <div className="account-settings__header-earned">Earned: £{earned}</div>
                <img src={DelimiterIcon} alt="delimiter" className="mx-3" />
                <div className="account-settings__header-donated">
                    {IS_SIDEKICK_APP ? 'Paid' : 'Donated'}: £{donated}
                </div>
            </ModalHeader>
            <ModalBody>
                <Container className="my-3" fluid>
                    <Row>
                        <Col sm={12} lg={4}>
                            <div className="form-group">
                                <label>First name</label>
                                <input
                                    type="text"
                                    name="firstName"
                                    className="form-control"
                                    placeholder="First name"
                                    value={
                                        accountDetailsDTO && accountDetailsDTO.firstName
                                            ? accountDetailsDTO.firstName
                                            : ''
                                    }
                                    onChange={onTextInputChange}
                                />
                            </div>
                        </Col>
                        <Col sm={12} lg={4}>
                            <div className="form-group">
                                <label>Second name</label>
                                <input
                                    type="text"
                                    name="lastName"
                                    className="form-control"
                                    placeholder="Second name"
                                    value={
                                        accountDetailsDTO && accountDetailsDTO.lastName
                                            ? accountDetailsDTO.lastName
                                            : ''
                                    }
                                    onChange={onTextInputChange}
                                />
                            </div>
                        </Col>
                        <Col sm={12} lg={4}>
                            <div className="form-group">
                                <label>Email Address</label>
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control"
                                    placeholder="Email"
                                    value={
                                        accountDetailsDTO && accountDetailsDTO.email
                                            ? accountDetailsDTO.email
                                            : ''
                                    }
                                    onChange={onTextInputChange}
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={6} lg={4}>
                            <div className="form-group">
                                <label>Industry</label>
                                <select
                                    type="text"
                                    name="category"
                                    className="form-control"
                                    placeholder="Industry"
                                    value={
                                        accountDetailsDTO && accountDetailsDTO.category
                                            ? accountDetailsDTO.category
                                            : ''
                                    }
                                    onChange={onTextInputChange}
                                >
                                    <option value="" default></option>
                                    {industries.map(industry => (
                                        <option key={industry.id} value={industry.text}>
                                            {industry.text}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={4}>
                            <div className="form-group">
                                <label>Professional title</label>
                                <input
                                    type="text"
                                    name="position"
                                    className="form-control"
                                    placeholder="Professional title"
                                    value={
                                        accountDetailsDTO && accountDetailsDTO.position
                                            ? accountDetailsDTO.position
                                            : ''
                                    }
                                    onChange={onTextInputChange}
                                />
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={4}>
                            <div className="form-group">
                                <label style={{ color: '#fff', userSelect: 'none' }}>button</label>
                                <input
                                    type="button"
                                    className={classNames('account-settings__general-button')}
                                    value="Edit"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </ModalBody>
            <PaymentSection />
            <SecuritySettings accountDetailsDTO={accountDetailsDTO} toggle={toggle} />
            <CloseAccount />
        </Modal>
    );
};

const condition = authUser => !!authUser;

export default compose(withAuthorization(condition))(AccountSettingsModal);
